export default __webpack_public_path__ + "static/media/img1.25504d6e.jpg";